import { Amplify } from 'aws-amplify';

export interface AmplifyConfig {
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId?: string;
  region: string;
}

export function configureAmplify(config: AmplifyConfig) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        identityPoolId: config.identityPoolId || '',
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: false,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });
}

// Configuration will be loaded from environment variables
export const amplifyConfig: AmplifyConfig = {
  userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
  identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || '',
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
};
